module.exports = __webpack_public_path__ + "static/media/feedback-icon.42e758b4.svg";